import styled from 'styled-components'

const StyledSelect = styled.select`
width: 100%;
min-width: 50px;
padding: 10px 12px;
margin: 10px 0px;
border-radius: 15px;
border: 1px solid lightgray;
text-align: center;
box-shadow: inset 0px 0px 3px lightgray;
color: gray;
`

export const DropDownOptions = props => {
    return <StyledSelect {...props}>
        {props.children}
    </StyledSelect>
}